import { Component, OnInit, HostListener, ChangeDetectionStrategy, ChangeDetectorRef, inject } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import {
  IStrapiDocuments,
  StudentWellbeingArticle,
} from 'src/app/interfaces/strapi';
import { ArticleService } from 'src/app/services/article.service';

import { DateFormatPipe } from 'src/app/shared/pipes/date-format.pipe';
import StrapiService from 'src/app/services/strapi.service';
import { RenderMarkdownComponent } from '../../../shared/components/render-markdown/render-markdown.component';
import { ProfileComponent } from '../profile/profile.component';
import { DateFormatPipe as DateFormatPipe_1 } from '../../../shared/pipes/date-format.pipe';

@Component({
    selector: 'app-wellbeing-article',
    templateUrl: './wellbeing-article.component.html',
    styleUrls: ['./wellbeing-article.component.scss'],
    providers: [DateFormatPipe],
  changeDetection:ChangeDetectionStrategy.OnPush,
    imports: [
        RenderMarkdownComponent,
        ProfileComponent,
        DateFormatPipe_1,
    ],
})
export class WellbeingArticleComponent implements OnInit {
  public article: StudentWellbeingArticle = <StudentWellbeingArticle>{};

  public isMobile: boolean = window.innerWidth <= 991;

  private cdr = inject(ChangeDetectorRef);

  @HostListener('window:resize')
  public onResize(): void {
    this.isMobile = window.innerWidth <= 991;
  }

  constructor(
    private readonly activeRoute: ActivatedRoute,
    public readonly articleService: ArticleService,
    public readonly strapi: StrapiService
  ) {}

  ngOnInit(): void {
    this.activeRoute.params.subscribe((params: Params) => {
      const { articleUid } = params;

      if (articleUid) {
        this.fetchArticleData(<string>articleUid);
      }
    });
  }

  private fetchArticleData(articleUid: string): void {
    this.strapi
      .getArticle(articleUid, 'STUDENTWELLBEING')
      .subscribe((document: IStrapiDocuments<StudentWellbeingArticle>) => {
        this.article = document.data[0].attributes;
        this.article.uid = document.data[0].attributes.uid ?? '';
        this.cdr.markForCheck()
      });
  }
}
